const PARAMETROS = {
    estadosAnimal: [{"id": 1, "text": "En adopción"}, {"id": 2, "text": "Urgente"}, {
        "id": 3,
        "text": "Adoptado"
    }, {"id": 4, "text": "Acogido"}, {"id": 5, "text": "Sacrificado"}, {"id": 6, "text": "En cuarentena"}],
    coloresAnimal: [{"id": 1, "text": "Blanco"}, {"id": 2, "text": "Negro"}, {"id": 3, "text": "Marrón"}, {
        "id": 4,
        "text": "Marrón claro"
    }, {"id": 5, "text": "Gris"}, {"id": 6, "text": "Beige"}, {"id": 7, "text": "Atigrado"}, {
        "id": 8,
        "text": "Azul"
    }, {"id": 9, "text": "Leonado"}],
    caractersAnimal: [{"id": 1, "text": "Alegre"}, {"id": 2, "text": "Juguetón"}, {"id": 3, "text": "Atento"}, {
        "id": 4,
        "text": "Fuerte"
    }, {"id": 5, "text": "Agresivo"}, {"id": 6, "text": "Tímido"}, {"id": 7, "text": "Tranquilo"}, {
        "id": 8,
        "text": "Noble"
    }, {"id": 9, "text": "Sociable"}, {"id": 10, "text": "Mimoso"}, {"id": 11, "text": "Dinámico"}, {
        "id": 12,
        "text": "Enérgico"
    }, {"id": 13, "text": "Cariñoso"}],
    edadesAnimal: [{"id": 1, "text": "C"}, {"id": 2, "text": "J"}, {"id": 3, "text": "A"}, {
        "id": 4,
        "text": "M"
    }, {"id": 5, "text": "AB"}],
    tamanosAnimal: [{"id": 1, "text": "MP"}, {"id": 2, "text": "P"}, {"id": 3, "text": "M"}, {
        "id": 4,
        "text": "G"
    }, {"id": 5, "text": "MG"}],
    tiposEntidad: [{"id": 1, "text": "Asociación"}, {"id": 2, "text": "Asociación CES"}, {
        "id": 3,
        "text": "Protectora"
    }, {"id": 4, "text": "Refugio"}, {"id": 5, "text": "Otro"}]
};

export default PARAMETROS;

